// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__R7sXj","icons":"Footer_icons__QDrf7","icon":"Footer_icon__Zscac","right":"Footer_right__ts+rg","credit":"Footer_credit__-Dp1R"};